import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
interface PricingCardProps {
  icon: string;
  title: string;
  features: string;
  idealFor?: string;
  oldPrice: string;
  newPrice: string;
  buttonText: string;
  href: string;
  highlighted?: boolean;
  delay?: number;
}
export function PricingCard({
  icon,
  title,
  features,
  idealFor,
  oldPrice,
  newPrice,
  buttonText,
  href,
  highlighted,
  delay = 0
}: PricingCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    delay
  }} className={`relative bg-navy-2 rounded-2xl p-7 md:p-9 flex flex-col h-full ${highlighted ? 'border-2 border-brand-gold shadow-[0_0_40px_rgba(245,158,11,0.15)] scale-100 md:scale-105 z-10' : 'border border-brand-blue-dark'}`} data-id="element-178">
      {highlighted && <div className="absolute -top-3.5 left-1/2 -translate-x-1/2 bg-brand-gold text-navy text-[11px] font-black tracking-[1px] uppercase py-1 px-4 rounded-full whitespace-nowrap" data-id="element-179">
          ⭐ Más elegido
        </div>}

      <div className="text-3xl mb-3" data-id="element-180">{icon}</div>
      <h3 className="text-lg font-black text-white mb-2" data-id="element-181">{title}</h3>
      <p className="text-sm text-brand-gray mb-4 min-h-[40px]" data-id="element-182">{features}</p>

      {idealFor && <div className="bg-navy-3 border border-brand-blue-dark/50 rounded-lg py-2 px-3 mb-6" data-id="element-183">
          <p className="text-[13px] text-brand-gray font-medium" data-id="element-184">{idealFor}</p>
        </div>}

      <div className="mt-auto pt-4 border-t border-[#1E293B]" data-id="element-185">
        <div className="text-sm text-brand-gray line-through mb-1" data-id="element-186">
          {oldPrice}
        </div>
        <div className="text-[clamp(32px,5vw,40px)] font-black text-brand-gold mb-6 leading-none" data-id="element-187">
          {newPrice}
        </div>
        <Button href={href} className="w-full text-[14px] md:text-[15px] px-4 py-4" data-id="element-188">
          {buttonText}
        </Button>
      </div>
    </motion.div>;
}